﻿'use strict';

angular.module('ntmApp')
  .directive('customListbox', function () {
      return {
          restrict: 'E',
          templateUrl: 'ng1/src/directives/templates/customListbox.html',
          scope: {
              value: '=',
              color: '=',
              data: '=',
              callback: '=',
              selectFirst: '='
          },
          link: function (scope) {
              if (scope.value) {
                  scope.selectedValue = scope.data.filter(function (item) { return item.id === scope.value; })[0].value;
              } else if (scope.selectFirst) {
                  scope.selectedValue = scope.data[0];
              } else {
                  scope.selectedValue = 'Please Select';
              }

              scope.selectedValue = scope.value ? scope.data.filter(function (item) { return item.id === scope.value; })[0].value : 'Please Select'; scope.notSelected = true;
              
              scope.change = function (item) {
                  scope.value = item.id || null;
                  scope.color = item.color || null;
                  scope.selectedValue = item.value || null;
                  scope.callback();
              };
          }
      };
  });